import {createSlice, PayloadAction} from '@reduxjs/toolkit';


const initialState = {
    loading: false,
    error: null,
    successMessage: null,
    success:false,
};


const ReviewLessonSlice = createSlice({
    name: 'reviewLesson',
    initialState,
    reducers: {
        successMessage: (state, action) => {
            state.successMessage = action.payload;
        },
        errorMessage: (state, action) => {
            state.error = action.payload;
        },
        successResponse: (state, action) => {
            state.success = action.payload;

        },
    },

});

export const reviewLessonReducer = ReviewLessonSlice.reducer;
export const {successMessage,successResponse, errorMessage} = ReviewLessonSlice.actions;

